module.exports = __webpack_public_path__ + "img/6-4.9e19c89f.jpg";